module.exports = __webpack_public_path__ + "img/oneGameBtn.f14df8da.png";